import { formatMatchDate } from "../formatMatchDate";
import { Localization } from "../../types/types";

interface DateStrings {
  WEEKDAYS: Record<string, string>;
  MONTHS: Record<string, string>;
}

export function formatLocalizedTimestamp(
  value: string,
  locale: Localization,
  strings: DateStrings,
): string {
  const parts = formatMatchDate(value, locale, strings);
  if (!parts) {
    return "";
  }
  return `${parts.date} ${parts.time}`;
}

export function formatTimestamp(value: string): string {
  return new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}
